import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { UserCard } from "../usercard/index.jsx";
import { AVATAR_SIZE, UserIcon } from "../usericon/index.jsx";
import { POPOVER_POSITIONS } from "../../feedback/popover/index.jsx";

import styles from "./userthumb.css";

export const USERTHUMB_POSITIONS = POPOVER_POSITIONS;

/**
 * Display user thumb in profile page
 */

export function UserThumb(props) {
  const {
    userId,
    className = "",
    actions,
    size,
    name,
    position,
    hiddenTypes
  } = props;
  return (
    <UserCard
      userId={userId}
      actions={actions}
      position={position}
      name={name}
      hiddenTypes={hiddenTypes}
    >
      <UserIcon
        className={`${styles.userThumb} ${className}`}
        userId={userId}
        size={size}
        name={name}
      />
    </UserCard>
  );
}

UserThumb.propTypes = {
  /**
   * Users id to display in user card
   */
  userId: PropTypes.string.isRequired,
  /**
   * styles to override in user card
   */
  className: PropTypes.string,
  /**
   * size of the user icon
   */
  size: PropTypes.oneOf(Object.values(AVATAR_SIZE)),
  /**
   * list of action to display while user hover the userthumb
   */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.func,
      buttonType: PropTypes.string,
      text: PropTypes.string,
      type: PropTypes.string
    })
  ),
  /**
   * Name of the user
   */
  name: PropTypes.string,
  /**
   * position of the user thumb to display
   */
  position: PropTypes.oneOf(Object.values(POPOVER_POSITIONS)),
  /**
   * hide the action if user provide some actions
   */
  hiddenTypes: PropTypes.arrayOf(PropTypes.string)
};
